import { AppConfig } from 'AppConfig';
import { fetchData } from 'features/user/userActions';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkAuth } from 'routes/checkAuth';
import routePaths from 'routes/routePaths';

const NewHome = () => {
  const navigate = useNavigate();
  const currentApp = useSelector((state) => state.user.currentApp);
  const currentTenantCd = useSelector((state) => state.user.currentTenantCd);

  const loadProfile = async () => {
    if (checkAuth()) {
      await fetchData(currentApp, currentTenantCd);

      switch (currentApp) {
        case AppConfig.APP_CODE_FO:
          navigate(routePaths.frontOffice);
          break;
        case AppConfig.APP_CODE_MASTER_DATA:
          navigate(routePaths.master);
          break;
        default:
          navigate(routePaths.frontOffice);
      }
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  return <></>;
};

export default NewHome;
